export default [
  {
    meta: {
      case_uuid: "azbtest_2644",
      date_event_filed: '09/15/2008',
      date_event_terminated: null,
      docket_no: 7,
      event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
      event_uri: null,
      order_docket_seq: '7.00000',
      timestamp: 1534169124.30955,
    },
    text: {
      case_uuid: "azbtest_2644",
      date_event_filed: '09/15/2008',
      date_event_terminated: null,
      docket_no: 7,
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
      event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
      event_uri: null,
      order_docket_seq: '7.00000',
      timestamp: 1534169124.30955,
      related: [{
        date_event_filed: '09/15/2008',
        date_event_terminated: null,
        docket_no: 7,
        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
        event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
        order_docket_no: 7,
        order_docket_seq: '1.00000',
      }],
    },
  }, {
    meta: {
      case_uuid: "azbtest_2644",
      date_event_filed: '09/15/2008',
      date_event_terminated: null,
      docket_no: 7,
      event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
      event_uri: null,
      order_docket_seq: '7.00000',
      timestamp: 1534169124.30955,
    },
    text: {
      case_uuid: "azbtest_2644",
      date_event_filed: '09/15/2008',
      date_event_terminated: null,
      docket_no: 1,
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
      event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
      event_uri: null,
      order_docket_seq: '1.00000',
      timestamp: 1534169124.30955,
      related: [{
        date_event_filed: '09/15/2008',
        date_event_terminated: null,
        docket_no: 1,
        docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
        event_name: "Motion to Authorize<i>: Debtor's Motion Pursuant to Sections 105(a), 342(a), and 521(a)(1) of the Bankruptcy Code, Bankruptcy Rules 1007(a) and 2002(a), (f) and (l), and Local Bankruptcy Rule 1007-1 for (i) a Waiver of the Requirement to File a List of Creditors and (ii) Approval of the Form and Manner of Notifying Creditors of the Commencement of the Debtor's Chapter 11 Case</i>filed by Harvey R. Miller on behalf of Lehman Brothers Holdings Inc.. (Miller, Harvey) (Entered: 09/15/2008)",
        order_docket_no: 1,
        order_docket_seq: '1.00000',
      }],
    },
  },
  {
    meta: {
      case_uuid: "azbtest_2644",
      date_event_filed: '09/15/2008',
      date_event_terminated: null,
      docket_no: 940,
      event_name: "Objection to Motion<i>//Limited Objection of the Pension Benefit Guaranty Corporation to Debtors' Motion for Entry of Order Pursuant to Sections 105, 363, and 365 of the Bankruptcy Code and Federal Rules of Bankruptcy Procedure 2002, 6004, 6006, and 9019: (I) Approving Equity Interests Purchase Agreement; (II) Authorizing Debtors to Compromise, Settle, and Release Related Claims and (III) Granting Certain Related Relief with attached Certificate of Service</i>(related document(s) <span class=\"docket_ref\">746</span>) filed by Colin B. Albaugh on behalf of Pension Benefit Guaranty Corporation. (Albaugh, Colin) (Entered: 10/14/2008)",
      event_uri: null,
      order_docket_seq: '940.00000',
      timestamp: 1534169124.30955,
    },
    text: {
      case_uuid: "azbtest_2644",
      date_event_filed: '09/15/2008',
      date_event_terminated: null,
      docket_no: 940,
      docket_uri: "https://ecf.nysb.uscourts.gov/doc1/12607320573",
      event_name: "Objection to Motion<i>//Limited Objection of the Pension Benefit Guaranty Corporation to Debtors' Motion for Entry of Order Pursuant to Sections 105, 363, and 365 of the Bankruptcy Code and Federal Rules of Bankruptcy Procedure 2002, 6004, 6006, and 9019: (I) Approving Equity Interests Purchase Agreement; (II) Authorizing Debtors to Compromise, Settle, and Release Related Claims and (III) Granting Certain Related Relief with attached Certificate of Service</i>(related document(s) <span class=\"docket_ref\">746</span>) filed by Colin B. Albaugh on behalf of Pension Benefit Guaranty Corporation. (Albaugh, Colin) (Entered: 10/14/2008)",
      event_uri: null,
      order_docket_seq: '940.00000',
      timestamp: 1534169124.30955,
      related: [],
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransactionArray.js